export default [
    {
        "id": 2349,
        "jd_id": 714,
        "is_attempted": true,
        "is_submitted": true,
        "link_deactivated": true,
        "jd_info": {
            "position": "python developer",
            "min_exp": 1,
            "max_exp": 5,
            "domain": "Python"
        },
        "candidate_name": "  Bheemaraju Ajay",
        "candidate_email": "ajaybittu605@gmail.com",
        "candidate_phone": "9912093252",
        "score": 0.0,
        "industry": null,
        "current_last_positon": null,
        "experience": "0.0",
        "education": null,
        "document": null,
        "meta": {
            "extras": {},
            "skills": [
                "Python",
                "Django"
            ],
            "contact_info": {
                "email": [
                    "ajaybittu605@gmail.com"
                ],
                "phone": [
                    "9912093252"
                ],
                "last_name": [
                    "Bheemaraju Ajay"
                ],
                "total_experience": [
                    0,
                    0
                ]
            },
            "primary_skills": [
                "Python",
                "Django"
            ],
            "secondary_skills": [
                ""
            ],
            "education_history": {},
            "employment_history": {}
        },
        "jd_designation": "python developer",
        "jd_skills": [
            "pytthon",
            "django",
            "django rest framework"
        ],
        "designation_score": 0.0,
        "certification_score": null,
        "experience_score": 0.0,
        "skills_score": 0.0,
        "entire_score": 0.0,
        "meta_from_ats": null,
        "ats_reference_id": null,
        "is_active": true,
        "created_at": "2025-04-07T10:37:22.342064Z",
        "updated_at": "2025-04-07T10:37:22.342075Z",
        "biometric_instance": 1496
    },
    {
    id: 101,
    jd_id: 714,
    is_attempted: true,
    is_submitted: true,
    link_deactivated: false,
    jd_info: {
      position: "React Developer",
      min_exp: 2,
      max_exp: 5,
      domain: "Frontend"
    },
    candidate_name: "Test1",
    candidate_email: "Test1@example.com",
    candidate_phone: "9876543210",
    score: 82.5,
    industry: "Software Development",
    current_last_positon: "Frontend Engineer",
    experience: "3.2",
    education: "B.Tech in Computer Science",
    document: null,
    meta: {
      extras: {},
      skills: ["React", "JavaScript", "Redux"],
      contact_info: {
        email: ["Test1@example.com"],
        phone: ["9876543210"],
        last_name: ["Sharma"],
        total_experience: [3, 2]
      },
      primary_skills: ["React", "JavaScript"],
      secondary_skills: ["Redux"],
      education_history: {},
      employment_history: {}
    },
    jd_designation: "React Developer",
    jd_skills: ["react", "javascript", "redux"],
    designation_score: 80.0,
    certification_score: 85.0,
    experience_score: 75.0,
    skills_score: 90.0,
    entire_score: 82.5,
    meta_from_ats: null,
    ats_reference_id: "ATS-001",
    is_active: true,
    is_selected: true,
    created_at: "2025-04-12T11:22:30.000Z",
    updated_at: "2025-04-12T11:22:30.000Z",
    biometric_instance: 1501,
  },
  {
    id: 102,
    jd_id: 715,
    is_attempted: true,
    is_submitted: false,
    link_deactivated: false,
    jd_info: {
      position: "Python Developer",
      min_exp: 1,
      max_exp: 4,
      domain: "Backend"
    },
    candidate_name: "Test2",
    candidate_email: "Test2@example.com",
    candidate_phone: "9825012345",
    score: 67.4,
    industry: "AI/ML",
    current_last_positon: "Backend Developer",
    experience: "2.0",
    education: "MCA",
    document: null,
    meta: {
      extras: {},
      skills: ["Python", "Django", "REST API"],
      contact_info: {
        email: ["Test2@example.com"],
        phone: ["9825012345"],
        last_name: ["Mehta"],
        total_experience: [2, 0]
      },
      primary_skills: ["Python", "Django"],
      secondary_skills: ["REST API"],
      education_history: {},
      employment_history: {}
    },
    jd_designation: "Python Developer",
    jd_skills: ["python", "django", "rest framework"],
    designation_score: 60.0,
    certification_score: null,
    experience_score: 70.0,
    skills_score: 72.0,
    entire_score: 67.4,
    meta_from_ats: null,
    ats_reference_id: "ATS-002",
    is_active: true,
    is_selected: false,
    created_at: "2025-04-14T10:15:45.000Z",
    updated_at: "2025-04-14T10:15:45.000Z",
    biometric_instance: 1502,
  },
  {
    id: 103,
    jd_id: 716,
    is_attempted: true,
    is_submitted: true,
    link_deactivated: false,
    jd_info: {
      position: "UI/UX Designer",
      min_exp: 1,
      max_exp: 6,
      domain: "Design"
    },
    candidate_name: "Test3",
    candidate_email: "Test3@example.com",
    candidate_phone: "9911122233",
    score: 78.9,
    industry: "Product Design",
    current_last_positon: "UI Designer",
    experience: "4.0",
    education: "B.Des",
    document: null,
    meta: {
      extras: {},
      skills: ["Figma", "Adobe XD", "Photoshop"],
      contact_info: {
        email: ["Test3@example.com"],
        phone: ["9911122233"],
        last_name: ["Kapoor"],
        total_experience: [4, 0]
      },
      primary_skills: ["Figma", "Adobe XD"],
      secondary_skills: ["Photoshop"],
      education_history: {},
      employment_history: {}
    },
    jd_designation: "UI/UX Designer",
    jd_skills: ["figma", "adobe xd", "illustrator"],
    designation_score: 85.0,
    certification_score: 75.0,
    experience_score: 80.0,
    skills_score: 76.0,
    entire_score: 78.9,
    meta_from_ats: null,
    ats_reference_id: "ATS-003",
    is_active: true,
    is_selected: true,
    created_at: "2025-05-01T09:20:10.000Z",
    updated_at: "2025-05-01T09:20:10.000Z",
    biometric_instance: 1503,
  },
  {
    id: 104,
    jd_id: 717,
    is_attempted: false,
    is_submitted: false,
    link_deactivated: true,
    jd_info: {
      position: "Data Analyst",
      min_exp: 2,
      max_exp: 6,
      domain: "Analytics"
    },
    candidate_name: "Test4",
    candidate_email: "Test4@example.com",
    candidate_phone: "9812345678",
    score: 0.0,
    industry: "Data Science",
    current_last_positon: "Junior Data Analyst",
    experience: "1.5",
    education: "B.Sc Statistics",
    document: null,
    meta: {
      extras: {},
      skills: ["Excel", "Power BI", "SQL"],
      contact_info: {
        email: ["Test4@example.com"],
        phone: ["9812345678"],
        last_name: ["Patel"],
        total_experience: [1, 6]
      },
      primary_skills: ["SQL", "Excel"],
      secondary_skills: ["Power BI"],
      education_history: {},
      employment_history: {}
    },
    jd_designation: "Data Analyst",
    jd_skills: ["sql", "excel", "power bi"],
    designation_score: 0.0,
    certification_score: null,
    experience_score: 0.0,
    skills_score: 0.0,
    entire_score: 0.0,
    meta_from_ats: null,
    ats_reference_id: "ATS-004",
    is_active: false,
    is_selected: false,
    created_at: "2025-04-20T08:45:00.000Z",
    updated_at: "2025-04-20T08:45:00.000Z",
    biometric_instance: 1504,
  },
  {
    id: 105,
    jd_id: 718,
    is_attempted: true,
    is_submitted: true,
    link_deactivated: false,
    jd_info: {
      position: "DevOps Engineer",
      min_exp: 3,
      max_exp: 8,
      domain: "Infrastructure"
    },
    candidate_name: "Test5",
    candidate_email: "Test5@example.com",
    candidate_phone: "9998877665",
    score: 88.3,
    industry: "Cloud Technology",
    current_last_positon: "DevOps Specialist",
    experience: "5.0",
    education: "B.Tech in IT",
    document: null,
    meta: {
      extras: {},
      skills: ["AWS", "Docker", "Kubernetes"],
      contact_info: {
        email: ["Test5@example.com"],
        phone: ["9998877665"],
        last_name: ["Verma"],
        total_experience: [5, 0]
      },
      primary_skills: ["AWS", "Docker"],
      secondary_skills: ["Kubernetes"],
      education_history: {},
      employment_history: {}
    },
    jd_designation: "DevOps Engineer",
    jd_skills: ["aws", "docker", "kubernetes"],
    designation_score: 88.0,
    certification_score: 90.0,
    experience_score: 85.0,
    skills_score: 89.0,
    entire_score: 88.3,
    meta_from_ats: null,
    ats_reference_id: "ATS-005",
    is_active: true,
    is_selected: true,
    created_at: "2025-05-02T07:55:00.000Z",
    updated_at: "2025-05-02T07:55:00.000Z",
    biometric_instance: 1505,
  }
]